export function isCoarsePointer() {
  return typeof window !== "undefined" && window.matchMedia("(hover: none) and (pointer: coarse)").matches
}

export function isEditableTarget(el: EventTarget | null) {
  if (!(el instanceof HTMLElement)) return false
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) return !el.readOnly && !el.disabled
  return el.isContentEditable
}

export function dismissVirtualKeyboard() {
  const active = document.activeElement
  if (active instanceof HTMLElement) active.blur()
}

export function visualViewportBottomInset(view: Pick<VisualViewport, "height" | "offsetTop"> | null = typeof window === "undefined" ? null : (window.visualViewport ?? null)) {
  if (typeof window === "undefined" || !view) return 0
  return Math.max(0, window.innerHeight - view.offsetTop - view.height)
}

/** Clearance between the sheet and the control it floats above. */
const SHEET_GAP = 6
/** Breathing room between the sheet and the screen edges. */
const SHEET_MARGIN = 8
/** Narrowest menu worth rendering, used to keep the sheet on screen. */
const SHEET_MIN_WIDTH = 144

export function mobileSheetMetrics(
  options: { inset?: number; anchorTop?: number; anchorLeft?: number } = {},
) {
  const inset = options.inset ?? visualViewportBottomInset()
  const viewport = typeof window === "undefined" ? { height: 0, width: 0 } : { height: window.innerHeight, width: window.innerWidth }
  const { anchorTop, anchorLeft } = options

  const bottom = anchorTop === undefined ? inset : Math.max(inset, viewport.height - anchorTop + SHEET_GAP)
  const maxHeight =
    anchorTop === undefined
      ? `min(70dvh, calc(100dvh - ${inset}px - env(safe-area-inset-top) - 12px))`
      : `min(70dvh, calc(${Math.max(0, anchorTop - SHEET_GAP)}px - env(safe-area-inset-top) - 12px))`

  const left = Math.max(
    SHEET_MARGIN,
    Math.min(anchorLeft ?? SHEET_MARGIN, viewport.width - SHEET_MARGIN - SHEET_MIN_WIDTH),
  )

  return {
    bottom: `${bottom}px`,
    maxHeight,
    left: `${left}px`,
    maxWidth: `calc(100vw - ${left}px - ${SHEET_MARGIN}px)`,
  }
}
